"use client";

import {useEffect} from "react";

/**
 * Hook that, on mount, scrolls to an element with the id specified in the URL hash.
 *
 * Usually isn't necessary since this is how browsers work by default,
 * but can be needed when there's race conditions with React rendering.
 *
 * @param scrollOptions
 */
const useScrollToHash = (scrollOptions?: ScrollIntoViewOptions) => {
	useEffect(() => {
		if (window.location.hash) {
			const id = window.location.hash.slice(1);
			const element = document.getElementById(id);
			if (element) {
				element.scrollIntoView(scrollOptions);
			}
		}
	}, [scrollOptions]);
};

/**
 * "Component" that just calls the hook, in case you need a client component.
 */
export const ScrollToHash = () => {
	useScrollToHash();
	return null;
};

export default useScrollToHash;
